import { FlexCol, FlexRow } from '@components'
import { type FC, useRef } from 'react'

import ECOPLANET_LOADER from '@assets/lightning_loader.json'
import { Player } from '@lottiefiles/react-lottie-player'

interface ILoadingPercent {
  isVisible: boolean
}

export const LoadingPercent: FC<ILoadingPercent> = ({ isVisible }) => {
  const playerRef = useRef<Player>(null)

  return (
    <>
      {isVisible && (
        <FlexCol>
          <FlexRow justifyContent={'center'}>
            <Player
              src={ECOPLANET_LOADER}
              className='player'
              ref={playerRef}
              autoplay
              loop
              id='lottiePlayer'
              style={{ height: '200px', width: '200px' }}
            />
          </FlexRow>
        </FlexCol>
      )}
    </>
  )
}
